export const messageSettings = {
    id: 'comparator.export.As',
    defaultMessage: 'Export to'
} as const;

export enum ExportValues {
    'pdf' = 'PDF',
    'excel' = 'Excel'
};

export enum ExportExtensions {
    'pdf' = 'pdf',
    'excel' = 'xlsx',
};

export enum ExcelProductRows {
    'image' = 'image',
    'name' = 'name',
    'url' = 'url',
    'bundleUrl' = 'bundleUrl',
    'price' = 'price'
};

export enum ExcelDirectionTypes {
    'rtl' = 'rtl',
    'ltr' = 'ltr'
};

export const EXCEL_DEFAULT_SETTINGS = {
    columns: {
        width: 28.6,
    },
    images: {
        height: 100,
        width: 100,
    },
    productImageRows: {
        height: 151.5,
    },
    products: {
        single: {
            tl: {
                row: 0.99,
                column: 0.9,
            }
        },
        bundle: {
            tl: {
                row: 0.5,
                column: 0.75,
            }
        }
    },
    startingColumn: {
        ltr: {
            index: 1,
        },
        rtl: {
            index: 0,
        },
    },
    startingRow: {
        index: 1,
    },
    fileName: 'Compare Products',
};

export const COMPARISON_EXCEL_BUNDLE_PRODUCT_KEY = 'bundleProduct';
export const COMPARISON_EXCEL_AUXILIARY_PRODUCT_KEY = 'auxiliaryProduct';
